import React from 'react';

const Meaning = ({ manager, data }) => {
  return (
    <div className="flex flex-wrap">
      <div className="hidden md:block w-1/4">
        <div className="block h-16 lg:h-24 w-16 lg:w-24 overflow-hidden rounded-full border-2 border-gray-600 xl:border-gray-300 my-3">
          <img
            src={manager.photoUrl}
            alt={manager.firstName}
            className="inline-block h-full w-full object-cover"
          />
        </div>
      </div>

      <div className="w-full md:w-3/4">
        <h5 className="border-b border-cf-300 pb-1 w-48">What this means</h5>
        <div className="text-sm mt-2">
          <p>
            <a href={data.link} rel="noopener noreferrer" target="_blank">
              {data.text} <br /> Source: {data.source}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Meaning;
